"use strict";

exports.__esModule = true;
exports["default"] = fullscreenReducer;

var _fullscreenActions = require("../actions/fullscreenActions.js");

var _initialState = _interopRequireDefault(require("./initialState.js"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function fullscreenReducer(state, action) {
  if (state === void 0) {
    state = _initialState["default"].fullscreen;
  }

  switch (action.type) {
    case _fullscreenActions.SET_SLIDE:
      return _lodash["default"].merge({}, state, {
        slideIdx: action.slideIdx
      });

    default:
      return state;
  }
}